import '.gq{border:var(--border-default);}.ssr-plugin'
import '.d6{background:var(--palette-white);}.ssr-plugin'
import '.b1{border-radius:1.25rem;}.ssr-plugin'
import { Property } from 'csstype'
import { styled, Style } from 'inlines'
import { ReactNode } from 'react'

export type CardWrapperProps = {
  children: ReactNode
  padding?: Property.Padding
  style?: Style
  onClick?: VoidFunction
}

export const CardWrapper = ({
  children,
  padding = '1rem',
  style,
  onClick,
}: CardWrapperProps) => {
  return (
    <styled.div className="gq d6 b1"
      onClick={onClick}
      style={{
        padding: padding,
        cursor: onClick ? 'pointer' : 'auto',
        ...style,
      }}
    >
      {children}
    </styled.div>
  )
}
